export default __webpack_public_path__ + "static/media/pns3.565d249f.png";